"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingThreadHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GamingThreadHeader = ({ closeThread, thread }) => {
    const onCloseThread = (event) => {
        const chatPanel = document.querySelector('.str-chat__main-panel');
        if (chatPanel)
            chatPanel.style.display = 'flex';
        closeThread(event);
    };
    const getReplyCount = () => {
        if (!(thread === null || thread === void 0 ? void 0 : thread.reply_count))
            return 0;
        return thread.reply_count;
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'thread-header', children: [(0, jsx_runtime_1.jsx)("button", { className: 'close-drawer-btn', onClick: onCloseThread }), (0, jsx_runtime_1.jsx)("h2", { children: `Thread (${getReplyCount()})` })] }));
};
exports.GamingThreadHeader = GamingThreadHeader;
